import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersRoleplayingConditionSearchItemsIndexResponseType } from "~/domains";

const request =
  async (): Promise<ApiManagersRoleplayingConditionSearchItemsIndexResponseType> => {
    const response =
      await new ApiClient().get<ApiManagersRoleplayingConditionSearchItemsIndexResponseType>(
        "/api/managers/roleplaying_condition_search_items",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersRoleplayingConditionSearchItemsIndex = ({
  config = {},
}: PropsType): UseQueryResult<ApiManagersRoleplayingConditionSearchItemsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersRoleplayingConditionSearchItemsIndex"],
    queryFn: () => request(),
  });
};
